export const ToggleList = {
  template: `
    <div class="relative toggle-list-section">
      <div class="w-full flex content-between toggle-list-box">
        <div class="py-[15px] lg:py-[7px] pl-2.5 w-full border-t border-l border-b lg:text-sm text-base border-secondary text-dark toggle-list-title">
          {{name}}
        </div>
        <div v-show="!show" @click.stop="display"  class="cursor-pointer w-10 bg-white flex justify-center items-center border-t border-r border-b border-secondary toggle-list-icon-off">
        <svg viewBox="0 0 20 30"  class="w-2 h-2 fill-current text-light list-advanced-svg-off" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 11.5L0.25 22.3253V0.674683L19 11.5Z"/>
        </svg>
        </div>
        <div v-show="show" @click.stop="display" class="cursor-pointer w-10 bg-primary border border-primary flex justify-center items-center toggle-list-icon-on">
        <svg viewBox="0 0 22 30" class="w-2 h-2 fill-current text-white list-advanced-svg-on" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.5 19L0.674683 0.25L22.3253 0.25L11.5 19Z" />
      </svg>
        </div>
      </div>
      <div v-show="show" class="pl-2.5 py-5 border border-t-0 border-secondary w-full z-20 bg-white toggle-list-content" :class="(isAbsolute) ? 'absolute' : ''">
        <p v-for="(item, i) in items" :key="i" class="leading-tight text-base lg:text-sm text-dark">{{item}}</p>
      </div>
    </div>
  `,
  props: ['name', 'items', 'layout'],
  data() {
    return {
      isAbsolute: this.layout === 'absolute',
      show: false,
      theme_directory: window.theme_directory,
    }
  },
  mounted() {
    this.$parent.$on('closeAllExcept', (who) => {
      if(this.name != who)
        this.show = false;
    })
  },
  methods: {
    display(){
      this.show = !this.show;
      if(this.show)
        this.$emit('toggleopened', this.name);
    },
  },
}
